import { Routes } from '@angular/router';
import { AUTH_ROUTES } from '@src/app/components/auth/auth.routes';
import { AuthGuard } from '@src/app/guards/auth.guard';
import { MainGuard } from '@src/app/guards/main.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('./components/auth/auth.component').then((m) => m.AuthComponent),
    children: AUTH_ROUTES,
    canActivate: [AuthGuard],
  },
  {
    path: 'main',
    loadComponent: () => import('./components/main/main.component').then((m) => m.MainComponent),
    title: 'Main',
    canActivate: [MainGuard],
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
